import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watch } from 'vue'
import confetti from 'canvas-confetti'

// bursts confetti from this element each time `trigger` increases

export default /*#__PURE__*/_defineComponent({
  __name: 'MatchingConfetti',
  props: {
    trigger: {},
    color: {}
  },
  setup(__props: any) {

const props = __props;



const anchorRef = ref<HTMLElement>()
const palette = ['#f7810a', '#ffd400', '#39b54a', '#2e9bd6', '#e23b6d', '#8e5ad6']

watch(() => props.trigger, (value, previous) => {
  if (value <= previous || !anchorRef.value) {
    return // only celebrate when the score goes up
  }
  const rect = anchorRef.value.getBoundingClientRect()
  confetti({
    particleCount: 90,
    spread: 80,
    startVelocity: 38,
    origin: { x: rect.left / window.innerWidth, y: rect.top / window.innerHeight },
    colors: props.color ? [props.color, ...palette] : palette,
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    ref_key: "anchorRef",
    ref: anchorRef,
    class: "confetti-anchor",
    "aria-hidden": "true"
  }, null, 512))
}
}

})